<template>
    <FinishProfile v-on:done="finish_profile = true;" v-if="!is_profile_completed && !finish_profile && getTenantAccess === null"/>
    <landlord-contracts v-else></landlord-contracts>
</template>

<script>
import LandlordContracts from "./contracts/LandlordContracts";
import FinishProfile from '../components/FinishProfile.vue';
import Vue from "vue";
import {mapGetters} from 'vuex';
export default {
    name: "Contracts",
    data: () => ({
        finish_profile: false,
        is_profile_completed: true,
    }),
    computed: {
        ...mapGetters(['getTenantAccess'])
    },
    components: {LandlordContracts, FinishProfile},
    mounted() {
        Vue.api.get('/user/dashboard', {}, {
            callback: (data) => {
                this.is_profile_completed = data.is_profile_completed;
            },
        });
    }
}
</script>

<style scoped>

</style>
